import { award as constants } from "store/constants";
import { reduceIsFetching, fetchableInitialState } from "store/factories/fetchable";


const initialState = {
	content: {
		award: {
			...fetchableInitialState,
			reviewEvents: [],
			certificationEvents: [],
		},
		values: {
			...fetchableInitialState,
			data: {},
		},
	},
};

export function award(state = initialState, action) {
	switch (action.type) {
		case constants.SINGLE_AWARD_IS_FETCHING:
			return {
				...state,
				content: {
					...state.content,
					award: reduceIsFetching(state.content.award, action),
				},
			};
		case constants.SINGLE_AWARD_SET_ERROR:
			return {
				...state,
				content: {
					award: {
						...state.content.award,
						error: action.payload,
					},
				},
			};
		case constants.SINGLE_AWARD_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
					...action.payload,
				},
			};

		case constants.SINGLE_AWARD_VALUES_IS_FETCHING:
			return {
				...state,
				content: {
					...state.content,
					values: reduceIsFetching(state.content.values, action),
				},
			};
		case constants.SINGLE_AWARD_VALUES_SET_ERROR:
			return {
				...state,
				content: {
					...state.content,
					values: {
						...state.content.values,
						error: action.payload,
					},
				},
			};
		case constants.SINGLE_AWARD_VALUES_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
					values: {
						...state.content.values,
						data: action.payload,
					},
				},
			};
		case constants.RESET:
			return initialState;
		default:
			return state;
	}
}
